import { type FC } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const rewardLabelVariants = cva('flex items-baseline justify-center', {
  variants: {
    variant: {
      default: css.rewardLabelDefault,
    },
    fontSize: {
      sm: 'text-sm',
    },
    fontWeight: {
      '700': 'font-bold',
    },
  },
});

interface RewardLabelProps extends VariantProps<typeof rewardLabelVariants> {
  className?: string;
  text: string;
  additional?: {
    text: string;
    className?: string;
  };
}

const RewardLabel: FC<RewardLabelProps> = ({
  variant = 'default',
  fontSize = 'sm',
  fontWeight = '700',
  additional,
  className,
  text,
}) => {
  return (
    <div className={cn(rewardLabelVariants({ variant }), className)}>
      {additional && (
        <span className={cn(additional.className, 'text-nowrap')}>
          {additional.text}
        </span>
      )}
      <span
        className={cn(
          rewardLabelVariants({ fontSize, fontWeight }),
          'leading-none',
        )}
      >
        {text}
      </span>
    </div>
  );
};

export { RewardLabel };
